import React from "react";
import {
  AppContainer,
  CardTitle,
  InfoCard,
  InfoRow,
  Label,
  MainContent,
  ProfileAvatar,
  ProfileContainer,
  ProfileImageContainer,
  ProfileImageSection,
  StatusBadge,
  Value,
} from "./style";

const UserProfile = ({ user }) => {
  const defaultProfileImage = `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(
    user.name
  )}&size=180&backgroundType=gradientLinear&fontWeight=500`;

  return (
    <AppContainer>
      <ProfileContainer>
        <ProfileImageSection>
          <ProfileImageContainer>
            <ProfileAvatar
              src={user.profile_img || defaultProfileImage}
              alt={user.name}
              onError={(e) => {
                e.target.src = defaultProfileImage;
              }}
            />
          </ProfileImageContainer>
          <StatusBadge isActive={user.is_active}>
            {user.is_active ? "نشط" : "غير نشط"}
          </StatusBadge>
        </ProfileImageSection>

        <MainContent>
          <InfoCard>
            <CardTitle>المعلومات الشخصية</CardTitle>
            <InfoRow>
              <Label>الاسم الكامل:</Label>
              <Value>{user.name}</Value>
            </InfoRow>
            <InfoRow>
              <Label>البريد الإلكتروني:</Label>
              <Value>{user.email}</Value>
            </InfoRow>
            <InfoRow>
              <Label>رقم الهاتف:</Label>
              <Value>{user.phone_number}</Value>
            </InfoRow>
            <InfoRow>
              <Label>نوع الحساب:</Label>
              <Value>{user.role === "USER" ? "مستخدم" : user.role}</Value>
            </InfoRow>
            <InfoRow>
              <Label>حالة الحساب:</Label>
              <Value>{user.blocked ? "محظور" : "غير محظور"}</Value>
            </InfoRow>
          </InfoCard>

          {user.additionalInfo && (
            <InfoCard>
              <CardTitle>معلومات إضافية</CardTitle>
              {/* Add any additional user info here */}
            </InfoCard>
          )}
        </MainContent>
      </ProfileContainer>
    </AppContainer>
  );
};

export default UserProfile;
